$(document).ready(function () {
  $("#personalize-box").on("change", function () {
    const variant = JSON.parse($("[data-current-variant-json]").text());
    let price = variant.price;
    if ($(this).is(":checked")) {
      $(".personalize-information input").each(function () {
        $(this).attr("name", $(this).attr("data-name"));
      });
      price += $("#personalize-price").data("numberValue");
      $("[data-personalisation-added]").removeClass("hide");
    } else {
      $("[data-personalisation-added]").addClass("hide");
      $(".personalize-information input").each(function () {
        $(this).removeAttr("name");
      });
    }
    if ($(this).prop('disabled')) {
      $("[data-personalisation-added]").addClass("hide");
    }
    $(".product-subtotal [data-product-price]").text(
      theme.Currency.formatMoney(price, theme.settings.moneyFormat)
    );
  });
  $(".add-icon").on("click", function () {
    $(this).toggleClass("active");
    $(this).next().toggleClass("hide");
  });
  $(".icon-popup li").on("click", function () {
    let value = $(this).text();
    let inputField = $(this).parents(".field-name").find("input");
    let newVal = inputField.val() + value;
    if (inputField.val().length < 12) {
      inputField.val(newVal).change();
      let data_op = inputField.attr("data-op");
      let image_text = $("." + data_op);
      image_text.text(newVal);
    } else {
      alert("Maximum characters reach.");
    }
    $(".add-icon").removeClass("active");
    $(".icon-popup").addClass("hide");
  });
  $(".field-name input").on("keyup", function () {
    let data_op = $(this).attr("data-op");
    let image_text = $("." + data_op);
    image_text.text($(this).val());
  });
  if ($(".field-font").length > 0) {
    $(".field-font select").on("change", function () {
      const personaliseWrapper = $(this).closest(".personalize_options");
      let selectedOption = $(this).find("option:selected");
      let selectedFont = selectedOption.data("font");
  
      $("#personalization-font").val(selectedOption.val());
  
      let data_op = personaliseWrapper.find(".field-name input").attr("data-op");
      let image_text = $("." + data_op);
  
      personaliseWrapper.find(".field-name input")
        .css("font-family", selectedFont)
        .addClass(selectedFont);
  
      image_text.css("font-family", selectedFont)
        .addClass(selectedFont);
    });
  }
  
  if ($(".field-color").length > 0) {
    $(".selected-color").text($(".field-color").find("li").first().text());
    $(".field-color").find("li").first().addClass("active");
    var dataColorActive = $(".field-color li.active").data("color");
    $(".fields-text-wrapper .fields-text").css("color", dataColorActive);
    $(".field-color li").on("click", function () {
      var dataColor = $(this).data("color");
      $(".fields-text-wrapper .fields-text").css("color", dataColor);
      $(".field-color li").removeClass("active");
      $(this).addClass("active");
      $(".selected-color").text($(this).text());
      $("#personalization-color").val($(this).text());
    });
  }

  function closeAllPopups() {
    document.querySelector("body").classList.remove("show-popup");
    document
      .querySelectorAll("[data-popup]")
      .forEach((el) => el.classList.remove("active"));
  }

  document.querySelectorAll("[data-popup-trigger]").forEach((el) =>
    el.addEventListener("click", function () {
      const popupToShow = el.dataset.popupTrigger;
      closeAllPopups();
      if (popupToShow) {
        const popup = document.querySelector(`[data-popup="${popupToShow}"]`);
        console.log(popup)
        if (popup) {
          popup.classList.add("active");
          document.querySelector("body").classList.add("show-popup");
        }
      }
    })
  );

  document.querySelectorAll(".close-popup").forEach((el) =>
    el.addEventListener("click", closeAllPopups)
  );

  document.addEventListener("click", function (e) {
    if (e.target.closest(".popup-wapper") || e.target.closest("[data-popup-trigger]")) return;
    closeAllPopups();
  });
});
